import { render } from "./AddParametrePage.vue?vue&type=template&id=25f2264e&ts=true"
import script from "./AddParametrePage.vue?vue&type=script&lang=ts"
export * from "./AddParametrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__